module.exports = __webpack_public_path__ + "static/img/2.cb3cbb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/eng/2.png
// module id = SRIB
// module chunks = 0